(function(){
  var FLAG='hbh_ext_modal_scrolled_v2';
  function checkbox(){return document.getElementById('hbh_preorder_checkbox');}
  function formFor(el){return (el&&el.closest&&el.closest('form[action*="/cart/add"]'))||document.querySelector('form[action*="/cart/add"]');}
  function syncProperty(form,box){
    if(!form||!box)return;
    var hidden=form.querySelector('input[data-hbh-preorder-property="true"]');
    if(box.checked){
      if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name='properties[Preorder Acknowledgement]';hidden.setAttribute('data-hbh-preorder-property','true');form.appendChild(hidden);}
      hidden.value=box.value;
    }else if(hidden){hidden.remove();}
  }
  function focusAck(box){if(!box)return;box.scrollIntoView({behavior:'smooth',block:'center'});box.focus();}
  function bindBox(){
    var box=checkbox();
    if(!box||box.dataset.hbhFixBound==='true')return;
    box.dataset.hbhFixBound='true';
    try{if(localStorage.getItem(FLAG)==='1'){box.disabled=false;var helper=document.getElementById('hbh_preorder_helper');if(helper)helper.style.display='none';}}catch(e){}
    box.addEventListener('change',function(){syncProperty(formFor(box),box);});
  }
  if(!document.documentElement.dataset.hbhPreorderFix){
    document.documentElement.dataset.hbhPreorderFix='true';
    document.addEventListener('submit',function(e){
      var form=e.target,box=checkbox();
      if(!form||!form.matches||!form.matches('form[action*="/cart/add"]')||!box)return;
      if(box.disabled||!box.checked){e.preventDefault();e.stopImmediatePropagation();focusAck(box);return;}
      syncProperty(form,box);
    },true);
    document.addEventListener('click',function(e){
      var btn=e.target&&e.target.closest?e.target.closest('button[name="add"],.product-form__submit,form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"]'):null;
      if(!btn)return;
      var form=formFor(btn),box=checkbox();
      if(!form||!box)return;
      if(box.disabled||!box.checked){e.preventDefault();e.stopImmediatePropagation();focusAck(box);return;}
      syncProperty(form,box);
    },true);
  }
  bindBox();
  document.addEventListener('shopify:section:load',bindBox);
})();